import React from "react";
import classnames from "classnames";
import TickList from "../tick-list/TickList";

// Styles
import styles from "./track-my-order.module.scss";

const listItems = ["When the items are on their way", "From the third party carrier before or on the day of delivery"];

function TrackMyOrder() {
  return (
    <div>
      <section>
        <h2>Tracking order online</h2>
        <p>
          You can track the progress of your order online. You&apos;ll also receive delivery updates by email or text
          message:
        </p>
        <TickList squeezed items={listItems} />
        <a
          className={classnames("c-button c-button--primary", styles["track-my-order__button"])}
          href="https://account.johnlewis.com/track-order"
        >
          Track order
        </a>
      </section>
    </div>
  );
}

export default TrackMyOrder;
